import { apiFetch } from "../../lib/utils";

export type SupplierContactRow = {
  id: number;
  supplierOrgId: string;
  firstName?: string | null;
  lastName?: string | null;
  mail: string;
  displayName?: string | null;
};

const base = "/NullReporting/api";

export const NullReportingContactsAPI = {
  async listSupplierContacts(orgNr: string): Promise<SupplierContactRow[]> {
    const res = await apiFetch(
      `${base}/suppliers/${encodeURIComponent(orgNr)}/contacts`,
      "GET",
      { "Content-Type": "application/json" }
    );
    if (!res.ok) throw new Error(`Failed to load contacts: ${res.status} ${res.statusText}`);
    return res.json();
  },
};
